<template>
  <div class="private">
    <div>
      <p style="margin: 0pt; text-align: right;">
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;">
          本版本更新时间：</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
          2021</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >年</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >10</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >月</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >8</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >日</span
        >
      </p>
      <p style="margin: 0pt; text-align: right;">
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >生效时间：</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
          2021</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >年</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >10</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >月</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >8</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >日</span
        >
      </p>
      <p style="margin: 0pt; text-align: right;">
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;">
        </span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >发布日期：</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
          2021</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >年</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >10</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >月</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >8</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >日</span
        >
      </p>
      <p style="margin: 0pt; text-align: right;">
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >欢迎你使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >服务！</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >五</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >矿证券</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >有限公司</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >（以下简称“我们”）非常重视你的隐</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >私保护和个人信息保护。本隐私政策适用于你通过任何方式使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >的各项服务。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >运营者的基本情况：</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >公司名称：</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿证券</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >有限公司</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >注册地址</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >：</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >深圳市南山区粤海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >街道海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >珠社区滨海大道</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >3165</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >号五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿金融</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >大厦</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >2401</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >常用联系</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >地址：</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >深圳市南山区粤海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >街道海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >珠社区滨海大道</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >3165</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >号五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿金融</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >大厦</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >2401</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >个人信息保护相关联系方式：</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >客户服务部电话</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >40018-40028</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >提供两类功能：（一）一般使用者用于浏览证券行情、财经资讯；（二）五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿证券</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >客户进行证券交易、交易查询等各项操作。如不同意本政策的任何内容或者无法理解相关内容，请不要进行后</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >续操作。开始使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，即表示你已充分理解并同意本隐私政策的全部内容。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >本隐私政策将帮助你了解以下内容：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >1</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、我们收集哪些信息</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >2</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、我们如何使用</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >Cookie</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >和同类技术</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >3</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、信息的存储</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >4</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、信息安全</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >5</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、我们如何使用信息</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >6</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、我们接入的第三方及如何</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >共享、转让、公开披露你的个人信息</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >7</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、你的权利</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >8</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、未成年人保护</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >9</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、变更</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
       <span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >10</span
          ><span
            style="
              color: #333333;
              font-family: 微软雅黑;
              font-size: 13.5pt;
              font-weight: bold;
            "
            >、与我们联系</span
          >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >本隐私政策具体内容如下：</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >1. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >我们收集哪些信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >1.1</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >收集哪些信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >当你使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >时，为保障你正常使用我们的服务，根据相关法律法规的要求，以及改进和优化我们的服务体验及保障你的账号安全的需要，下列描述是我们会为你提供的功能、服务以及各项业务功能和服务会收集的个人信息：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1.1.1</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >注册安装</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >根据中国证监会《关于加强证券期货经营机构客户交易终端信息等客户信息管理的规定》的规定，你在通过五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >进行开户交易时需要保存留痕你的</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >手机号码、手机短信验证码、登录</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IP</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >地址、手机</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMEI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >码、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMSI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >码、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
            text-decoration: line-through;
          "
          >平板电脑序列号</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、版本、设备识别码、设备标识</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >内容。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >安装五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >需要获取的终端文件权限包括你终端设备的</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >存储</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >/</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >缓存文件信息</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，你在登录、注册、使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >内各项服务时，需要你访问你</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >设备存储文件读写权限</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >来安装、缓存五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >相关文件。同时为了保证你能够</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >正常访问</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >网络，五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >需要</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >获取</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >你设备访问并使用网络及</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >WIFI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >的权限</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。如果你不同意提供前述相关权限，可能导致无法正常使用上述功能。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1.1.2</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >行情交易</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们会为你提供互联网股票行情和交易服务的业务功能，包括为你提供股票信息、大盘指数展示等服务，以及基于你本人账户的证券交易服务，根据你的指令提供证券买入、证券卖出等服务。在股票交易业务</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >功能中，</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >你将提供个人资金账户</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，同时由于监管要求，交易信息中需要包含手机设备信息（你的硬件型号、操作系统版本、设备配置、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >唯一设备标识符、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMEI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >MAC</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >地址</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >）作为该功能的必要条件，你的</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >资金账号、股东代码、营业部</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >信</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >息会加密后存储在设备本地（交易密码信息将不会被存储在设备本地）。存储的账号信息将用于后续帮助你快速进行交易登录，不会用于其他用途。你可以在设备的管理功能中清除这些账号信息，清除账号信息不影响五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >的正常使用。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1.1.3</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >转账及资产信息查询</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >为了你能够实时查看自己账户的证券持仓情况，我们会记录你账户的持仓证券和委托交易记录，以帮助你实时了解自己的资产变动情况。为了准确执行你的交易指令，在你使用银证转账和资产查询信息时，需获取你的手机设备信息、账号信息、身份信息、银行账户信息，包括</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMEI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IP</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >地址、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >MAC</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >地址、交易账号、口令（交易密码、资金密码）</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。同时若你使用银行余额查询功能时，需要你输入</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >银行卡密码</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >作为查询的必要条件，如你不提供前述信息，相应功能可能无法进行，但不影响你使用我们提供的其他服务。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >1.2</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >在五矿期权宝</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >APP</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >的运行过程中，应用程序将会自动采集如下信息：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1.2.1</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >日志分析</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在你使用我们产品的过程中会产生日志信息，日志中将会收集你的手机设备信息（你的</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >硬件型号、操作系统版本、设备配置、唯一设备标识符、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMEI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >MAC</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >地址</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >）。为了给你提供更好的服务，我们会对日志信息进行分析，在此基础上对五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >进行优化升级。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1.2.2</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >运营分析</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你在使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >时五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >将会记录你在应用中的行为信息，包括手机设备信息（若你开启了相关权限，则会收集</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMEI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >IMSI</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >、地理位置信息、</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >Mac地址、IP地址、手机型号、操作系统版本、ANDR</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >OID</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >_ID、UUID）</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >这些数据将用于进行运营分析，如：各功能的打开率、各功能的访问时长、各地区的功能使用情况分析功能，运营分析将会帮助我们改善产品功能。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >其他</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >请你理解，我们向你提供的服务是不断更新和发展的。如你选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集你的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向你说明信息收集的范围与目的，并征得你的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护你的信息；如你选择不提供前述信息，你可能无法使用某项或某部分服务</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >1.3</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >事先征得授权同意的例外</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在以下情形中，收集、使用个人信息无需事先征得你的授权同意</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >:</span
        >
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt;">
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >1</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）与国家安全、国防安全有关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >2</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）与公共安全、公共卫生、重大公共利益有关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >3</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）与犯罪侦查、起诉、审判和判决执行等有关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >4</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >5</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）所收集的个人信息是个人信息主体自行向社会公众公开的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >6</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >7</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）根据你的要求签订合同所必需的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >8</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）用于维护所提供的产品与</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >/</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >或服务的安全稳定运行所必需的，例如发现、处置产品与</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >/</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >或服务的故障；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >9</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）为合法的新闻报道所必需的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >10</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）学术研究机构基于公共利益开展统计或学术研究所必要，</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >且对外</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >（</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >11</span
          ><span
            style="font-family: 微软雅黑; font-size: 13.5pt; font-weight: bold;"
            >）法律法规规定的其他情形。</span
          >
        </li>
      </ul>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >1.4</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >我们申请的设备权限</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在提供服务过程中，会调用你的一些设备权限。以下是五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >调用涉及个人信息的权限对应的业务功能、调用权限的目的以及调用权限前向你询问的情况。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0pt;"
      >
        <thead>
          <tr>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >权限名称</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >对应业务功能</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >调用权限的目的</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >是否询问</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >是否可以关闭权限</span
                >
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >读取本机设备信息</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >证券行情、交易、运营分析</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >1</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、监管要求，证券交易需要留痕。</span
                >
              </p>
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >2</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、五矿期权宝</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >的运营分析会采集设备信息。</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >网络请求</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >数据相关连接请求</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >,</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >网络状态监听</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >1</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >行情</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >,</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >交易数据相关连接请求</span
                >
              </p>
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >2</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >网络是否连接监听</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >否</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >访问外部存储</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >更新</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >1</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、用于下载存储五矿期权宝</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >最新安装包。</span
                >
              </p>
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >2</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、用于缓存五矿期权宝</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >资源，提升体验。</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >查看当前运行应用列表</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >提示客户五矿期权宝</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >已进入后台运行</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >判断五矿期权宝</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >APP</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是否处于后台运行状态</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >否</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >是</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >2. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >我们如何使用</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >Cookie</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >和同类技术</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >是支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制。当你在使用部分功能的时候，我们会向你的设备发送一个或多个</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >或匿名标识符。当你与这些功能产生交互时，我们允许</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >或者匿名标识符发送给五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >服务器。</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >通常包含一些随机生成的字符。运用</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >技术，五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >能够了解你的使用习惯，或帮你判断你账户的安全性。</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >还可以帮助我们统计流量信息，分析页面设计的有效性。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们不会将</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
          Cookie </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >用于本政策所述目的之外的任何用途。你可根据自己的</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >偏好管理或删除</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
          Cookie</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >3. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >信息的存储</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用你的信息，我们将再次向你进行说明，并征得你的同意。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >所收集的用户个人信息，在互联网线路通过加密传输存放至我们的系统服务器，进行加密存储，我们的机房管理、服务器管理、网络管理以及五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >应用安全均严格遵守国家信息系统安全等级保护</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >(</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >三级</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >)</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。我们仅在本政策所述目的所必需期间和法律法规、监管规定的期间内保存你的信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >3.1</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >信息存储的地点</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们会按照法律法规规定，将在中国境内收集和产生的个人信息存储于中国境内。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >3.2</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >信息存储的期限</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >一般而言，我们仅为实现目的所必需的时间保留你的个人信息。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，在合理的期限内删除你的个人信息或进行匿名化处理，并立即停止收集个人信息的活动。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >根据《中华人民共和国证券法》要求，我们将会按照规定的期限保存你的身份资料、交易记录。根据《证券法》规定，证券期货经营机构应妥善保存客户开户资料、委托记录、交易记录相关资料，保存期限不得少于二十年。除此之外的个人信息，我们仅在你注销账号前保存。当你的个人信息超出我们所保存的期限后，我们将会对你的个人</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >信息进行删除或匿名化处理。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >4. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >信息安全</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >SSL</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >）、匿名化处理等手段来保护你的个人信息。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >设备本地</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >完成部分信息加密的工作。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >们遵守保密义务，并进行审计。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >目前，我们通过了国家网络安全等级保护（三级）的测评和备案。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >5. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >我们如何使用信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >5.1</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >保障服务的稳定性与安全性</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >为了确保服务的安全帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >为了保障服务的稳定</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >性与安全性，我们会将你的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >5.2</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >根据法律法规或监管要求向相关部门进行报告。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >5.3</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >我们会采取脱敏、去标识化等方式对你的信息进行综合统计、分析加工，以便为你提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善或设计服务及运营活动。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >5.4</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >当我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征得你的同意。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >如我们使用你的个人信息，超出了与收集时所声称的目的</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >6. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >我们接入的第三方及我们如何共享、转让、公开披露你的个人信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >6.1</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >我们接入的第三方</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >为了使你能够接收信息推送、在第三方平台分享信息、利用第三方账号登录五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >以及运营统计的需要，我们的应用中接入了第三方</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >SDK</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，具体第三方信息如下表所述：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0pt;"
      >
        <thead>
          <tr>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >第三方名称</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >第三方需要申请的权限</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >第三方提供的功能</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #dedede;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: 宋体;
                    font-size: 8.5pt;
                    font-weight: bold;
                  "
                  >第三方收集的个人信息</span
                >
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p
                style="margin: 0pt; padding-left: 10.5pt; text-indent: -10.5pt;"
              >
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >腾讯</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >Bugly</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                >
                </span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >SDK</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >网络</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >权限</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、获取设备信息</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、读取手机状态和身份</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >，</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >上传崩溃日志</span
                >
              </p>
              <p style="margin: 0pt;">
                <span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >&#xa0;</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >消息推送</span
                >
              </p>
            </td>
            <td
              style="
                background-color: #ffffff;
                border-bottom-color: #666666;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #666666;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #666666;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #666666;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 5.62pt 1.12pt;
                vertical-align: middle;
              "
            >
              <p style="margin: 0pt;">
                <span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >手机设备信息（</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >手机型号</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >、操作系统版本）</span
                ><span
                  style="
                    color: #333333;
                    font-family: Verdana;
                    font-size: 8.5pt;
                  "
                  >,</span
                ><span
                  style="color: #333333; font-family: 宋体; font-size: 8.5pt;"
                  >错误日志信息</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >6.2 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >如何共享、转让、公开披露你的个人信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们在事先获得你的明确同意的情况下，依法共享、转让、公开披露你的个人信息。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >6.2.1</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >个人信息的共享</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们承诺对你的信息进行严格保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享你的个人信息，第三方包括合作金融机构以及其它合作伙伴。在共享你的个人信息前，我们会对第三方的个人信息安全防护能力水平提出要求，确保其收集使用个人信息行为的合法性、正当性、安全性、必要性，与其签订保密协议，督促其遵守国家法律法规及协议中约定的安全防护措施和保密条例，一旦发现其违反协议约定将会采取有效措施甚至终止合作。以下情形会共享你的个人信息：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >（</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >1</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >）如你选择参与我们的抽奖、竞赛或类似推广活动，为了能及时准确向你发放</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >奖品或为你提供服务，我们可能会将你在活动中填写的手机号码、收件人姓名、收件人地址信息共享给第三方礼品供应商，由礼品供应商负责将奖品发放至你的手中；</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >（</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >2</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >）如你的交易发生纠纷或争议，为了解决此类问题，我们可能需要与银行、交易方或其他金融机构共享你的姓名、有效证件号码、联系方式、纠纷内容；</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >6.2.2</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >个人信息的转让</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们不会将你的个人信息转让给除五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿证券</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >有限公司及其关联公司外的任何公司、组织和个人，但以下情况除外：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，你的个人信息有可能作</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >为此类交易的一部分而被转</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >移，我们将确保该等信息在转移时的机密性，并尽最大可能确保新的持有你个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向你征求授权同意。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >6.2.3</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >个人信息的公开披露</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们仅会在以下情况下，公开披露你的个人信息：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >(1)</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >获得你的明确同意；</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >(2)</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >6.2.4</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露你的个人信息无需征得你的同意：</span
        >
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt;">
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">1</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）与国家安全、国防安全直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">2</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）与公共安全、公共卫生、重大公共利益直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">3</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">4</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">5</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）所收集的个人信息是个人信息主体自行向社会公众公开的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">6</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">7</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）根据个人信息主体要求签订和履行合同所必需的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">8</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">9</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）个人信息控制者为新闻单位</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >且其在开展合法的新闻报道所必需的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">10</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">11</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）法律法规、法律程序的要求或强制性的政府要求或司法裁定的其他情形。</span
          >
        </li>
      </ul>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >7. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >管理您</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >的</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在你使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >期间，为了你可以更加便捷地访问、更正、删除你的个人信息，同时保障你撤回对个人信息使用的同意及注销账号的权利，我们在产品设计中为你提供了相应的操作设置。此外，我们还设置了投诉举报渠道，你的意见将会得到及时的处理。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.1</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >访问查看你的个人信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >除法律法规规定的例外情况，无论你何时使用我们的服务，我们都会力求让你顺利访问自己的个人信息。你可以在网上营业厅业务办理中查看个人基本信息、账户信息。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.2 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >修改更正你的个人信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >当你需要修改更正你的个人信息时，或发现我们处理你的个人信息有错误时，</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你有权</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >作出</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >更新和更正。你可以在网上营业厅业务办理功能中进行修改更正。由于监管要求，部分涉及身份变更的信息需要你前往营业厅临柜办理更正。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.3</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >删除你的个人信息</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在以下情形中，你可以向我们提出删除个人信息的请求：</span
        >
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt;">
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">1</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）如果我们处理个人信息的行为违反法律法规；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">2</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）如果我们收集、使用你的个人信息，却未征得你的同意；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">3</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）如果我们处理个人信息的行为违反了与你的约定；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">（</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;">4</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >）如果我们终止服务及运营。</span
          >
        </li>
      </ul>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >若出现上述情况，你可以通过分支机构网点柜面办理注销资金账户，我们会在三个工作日内处理完成，特殊情形下最长将在不超过十五个工作日期限内</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >作出</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >答复。你在注销资金账户后，我们将不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们仍需按照监管政策要求的留存时间进行保存，且在该依法保存的时间内有权机关仍可依法查询。当存储期限满足监管要求后，我们将会响应你的删除请求，对你的个人信息进行删除或匿名化处理。当我们删除相关信息后，可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.4 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >撤销你的授权</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你可以通过设备系统权限设置撤销授权。请你理解，每个业务功能需要一些基本的个人信息才能得以完成，当你撤回同意或授权后，我们无法继续为你提供撤回同意或授权所对应的服务，也</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >不</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >再处理</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你相应</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >的个人信息。但你撤回同意或授权的决定，不会影响此前基于你的授权而开展的个人信息处理。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.5 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >注销你的账户</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >注销资金账户：你可以通过分支机构网点柜面办理注销资金账户，我们会在三个工作日内处理完成，特殊情形下最长将在不超过十五个工作日期限内</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >作出</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >答复。一旦你注销账号，将无法使用我们部分用户产品的服务，因此请你谨慎操作。我</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >们为了保护你或他人的合法权益，会结合你对我们各产品的使用情况判断是否支持你的注销请求。例如你的账户中留有持仓股票的情况下，你将无法注销账号。注销</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >帐号</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >之后我们将停止为你提供产品和服务。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >根据有关监管规定，你在使用五矿期权宝</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >APP</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >服务期间提供和产生的信息我们仍需按照监管要求的时间限制进行保存，且在保存期间依法配合有权机关的查询。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.6 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >获取你的个人信息副本</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你有权获取你的个人信息副本。如你需要获取我们收集的你的个人信息副本，你可通过拨打客服热线</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >4001840028</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >，人工客服会对你进</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >行身份核验后，将个人信息副本</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >提交给你。在符合相关法律规定且技术可行的前提下，我们将根据你的要求向你提供您的个人信息副本。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.7 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >响应你的请求</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >如果你无法通过上述方式访问、更正、删除你的个人信息，或你认为我们存在任何违反法律法规或与你关于个人信息的收集或使用的约定，你均可以通过发送电子邮件至</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >jubao@wkzq.com.cn</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >的方式联系我们。我们将在</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >15</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >个工作日内回复你的访问请求。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们将</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >尽合理</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >的商业努力，满足你对于个人信息的访问、更正、删除、撤销、管理的要求，但对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >7.8 </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >例外</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >在以下情形中，按照法律法规要求，我们将无法响应你的更正、删除、注销信息的请求：</span
        >
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt;">
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(1)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >与国家安全、国防安全直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(2)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >与公共安全、公共卫生、重大公共利益直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(3)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >与犯罪侦查、起诉、审判和执行判决等直接相关的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(4)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >我们有充分证据表明你存在主观恶意或滥用权利的（如你的请求将危害公共安全和其他人合法权益，或你的请求超出了一般技术手段和商业成本可覆盖的范围）；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(5)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >响应个人信息主体的请求将导致你或其他个人、组织的合法权益受到严重损害的；</span
          >
        </li>
        <li
          style="
            font-family: serif;
            font-size: 10pt;
            margin: 0pt 0pt 6pt 9.6pt;
            padding-left: 8.4pt;
            text-indent: 0pt;
          "
        >
          <span style="font-family: 微软雅黑; font-size: 13.5pt;">(6)</span
          ><span style="font-family: 微软雅黑; font-size: 13.5pt;"
            >涉及商业秘密的。</span
          >
        </li>
      </ul>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >8. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >未成年人保护</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >14</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >周岁以下的未成年人，在使用五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过第</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >10</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >节中的联系方式与我们联系。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >9. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >变更</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们可能会适时对本政策进行修订。当政策的条款发生变更时，我们会在你登录及版本更新时</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >以弹窗的</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >形式向你展示变</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >更后的指引。请你注意，只有在你点击弹窗中的同意按钮后，我们才会按照更新后的指引收集、使用、存储你的个人信息。你可以在五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >中随时查看本政策。</span
        >
      </p>
      <p style="margin: 5pt 0pt 15pt;">
        <span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >10. </span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 12pt;
            font-weight: bold;
          "
          >与我们联系</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >你对五矿期权宝</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >APP</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >有任何意见或建议可拨打客服热线</span
        ><span
          style="
            color: #333333;
            font-family: 微软雅黑;
            font-size: 13.5pt;
            font-weight: bold;
          "
          >4001840028</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >,</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >工作时间为交易日的</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >8:30-17:00</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >。</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >对本隐私政策条款的问题，你可以将你的问题寄到如下地址：</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >深圳市南山区粤海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >街道海</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >珠社区滨海大道</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >3165</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >号五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿金融</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >大厦</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >2401</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿证券</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >有限公司</span
        ><span
          style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
        >
        </span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >法律事务部（收）</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >邮编：</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >518035</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >我们将尽快审核所涉问题，并在验证你的用户身份后的十五天内予以回复。</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p
        style="margin: 0pt 0pt 11.25pt; text-align: justify; text-indent: 24pt;"
      >
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >&#xa0;</span
        >
      </p>
      <p style="margin: 0pt; text-align: right;">
        <span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >五</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >矿证券</span
        ><span style="color: #333333; font-family: 微软雅黑; font-size: 13.5pt;"
          >有限公司</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span style="font-family: Calibri; font-size: 10.5pt;">&#xa0;</span>
      </p>
    </div>
    <div class="cnzz" style="display: none;"></div>
  </div>
</template>
<style>
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
<script>
import "../../service/td-h5-hybird-sdk";
export default {
  name: "klineindex",
  components: {},
  directives: {},
  data() {
    return {};
  },
  // {data:[]}
  computed: {},
  activated() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="less">
@import "./style/private.less";
</style>
<style></style>
